import React, { useEffect, useState, useCallback } from 'react';
import Tabs from 'cccisd-tabs';
import { client } from 'cccisd-apollo';
import Loader from 'cccisd-loader';
import _get from 'lodash/get';
import notification from 'cccisd-notification';
import sitesQuery from './sitesQuery.graphql';
import Administer from './administer';
import Progress from './progress.js';

const Fortress = window.cccisd.fortress;

export default function SingleLink() {
    const [loading, setLoading] = useState(true);
    const [sites, setSites] = useState([]);
    const [selectedSiteId, setSelectedSiteId] = useState('');
    const [parentDeploymentIds, setParentDeploymentIds] = useState([]);

    const fetchGroupLinkData = useCallback(async () => {
        setLoading(true);
        try {
            const orgId = Fortress.user.acting.group_id;
            const response = await client.query({
                query: sitesQuery,
                fetchPolicy: 'network-only',
                variables: {
                    orgFilter: `org_${orgId}`,
                },
            });

            setSites(response.data.groups.siteList || []);
            setParentDeploymentIds(_get(response, 'data.flows.deploymentList', []));
        } catch (error) {
            notification({
                type: 'danger',
                message: 'Unable to load Sites. Please refresh and try again.',
            });
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchGroupLinkData();
    }, [fetchGroupLinkData]);

    if (loading) {
        return <Loader loading />;
    }

    const tabList = [
        {
            name: 'administer',
            title: 'Administer',
            content: (
                <Administer
                    sites={sites}
                    selectedSiteId={selectedSiteId}
                    onSiteChange={setSelectedSiteId}
                    parentDeployments={parentDeploymentIds}
                />
            ),
        },
        {
            name: 'progress',
            title: 'Progress',
            content: (
                <Progress
                    sites={sites}
                    selectedSiteId={selectedSiteId}
                    onSiteChange={setSelectedSiteId}
                    parentDeployments={parentDeploymentIds}
                />
            ),
        },
    ];

    return (
        <div>
            <h1>Single Link</h1>
            <Tabs tabList={tabList} />
        </div>
    );
}
